<template>
  <v-container fluid>
    <page-header
      title="개인정보 접속기록"
      :useList="buttonUseList"
      :usePermission="false"
      @btnSearch="retrieve"
    />
    <v-row>
      <v-col class="py-2">
        <v-card class="px-4">
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field
                dense outlined hide-details
                label="계정(아이디)"
                v-model="retrieveData.userId"
                @keyup.enter="retrieve"
              />
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                dense outlined hide-details
                label="정보주체 ID"
                v-model="retrieveData.subjectId"
                @keyup.enter="retrieve"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-text-field
                dense outlined hide-details
                label="접속 IP"
                v-model="retrieveData.ipAddr"
                @keyup.enter="retrieve"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-select
                dense outlined hide-details
                label="수행업무"
                :items="operationTypeList"
                item-value="value"
                item-text="label"
                v-model="retrieveData.operationType"
              />
            </v-col>
            <v-col cols="12" md="2">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="retrieveData.date"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    dense outlined hide-details
                    v-model="rangeText"
                    label="기간"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker v-model="retrieveData.date" no-title scrollable range>
                  <v-spacer />
                  <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="changeDatePicker">OK</v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row class="justify-end">
      <v-col cols="12">
        <v-btn small outlined class="excel_down default-btn" @click="excelDown">
          {{ $t('label.download-excel') }}
        </v-btn>
      </v-col>
      <v-col>
        <real-grid
          ref="dataGrid"
          class="mt-1 mb-5 w-full"
          :options="grid.gridOption"
          :fields="grid.gridFields"
          :columns="grid.gridColumns"
          :height="grid.height"
          :retrieve-api="gridRetrieveApi"
          :retrieve-data="retrieveData"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import day from 'dayjs'
import DispatchResize from '@/mixins/DispatchResize'
import PageHeader from '@/layout/components/PageHeader'
import RealGrid from '@/components/grid/Realgrid'
import { getPersonalInfoAccessLog } from '@/api/manager/log/logManagement'

export default {
  name: 'personal-info-log',
  components: { PageHeader, RealGrid },
  mixins: [DispatchResize()],
  data() {
    return {
      menu: false,
      buttonUseList: ['btnSearch'],
      operationTypeList: [
        { value: '', label: '전체' },
        { value: '조회', label: '조회' },
        { value: '입력', label: '입력' },
        { value: '정정', label: '정정' },
        { value: '삭제', label: '삭제' }
      ],
      retrieveData: {
        date: [],
        startDate: '',
        endDate: '',
        userId: '',
        subjectId: '',
        ipAddr: '',
        operationType: ''
      },
      grid: {
        height: 500,
        gridOption: {
          gridView: {
            edit: {
              appendable: false,
              insertable: false,
              deletable: false,
              editable: false
            },
            checkBar: { visible: false },
            panel: { visible: false },
            stateBar: { visible: false },
            rowIndicator: { visible: false },
            display: { fitStyle: 'even' }
          },
          dataProvider: {
            softDeleting: true,
            deleteCreated: true
          }
        },
        gridFields: [
          { fieldName: 'logId',         dataType: 'string' },
          { fieldName: 'userId',        dataType: 'string' },
          { fieldName: 'accessDt',      dataType: 'string' },
          { fieldName: 'ipAddr',        dataType: 'string' },
          { fieldName: 'operationType', dataType: 'string' },
          { fieldName: 'subjectId',     dataType: 'string' },
          { fieldName: 'menuId',        dataType: 'string' },
          { fieldName: 'apiUrl',        dataType: 'string' },
          { fieldName: 'httpMethod',    dataType: 'string' },
          { fieldName: 'actionDesc',    dataType: 'string' }
        ],
        gridColumns: []
      }
    }
  },
  created() {
    this.retrieveData.date.push(day().add(-7, 'day').format('YYYY-MM-DD'))
    this.retrieveData.date.push(day().format('YYYY-MM-DD'))
    this.retrieveData.startDate = day(this.retrieveData.date[0]).format('YYYYMMDD')
    this.retrieveData.endDate   = day(this.retrieveData.date[1]).format('YYYYMMDD')
    this.createGridColumns()
  },
  async mounted() {
    this.retrieve()
  },
  computed: {
    rangeText() {
      return this.retrieveData.date.join(' ~ ')
    },
    gridRetrieveApi() {
      return getPersonalInfoAccessLog
    }
  },
  methods: {
    retrieve() {
      this.$refs.dataGrid.retrieve()
    },
    excelDown() {
      this.$refs.dataGrid.excelDown()
    },
    changeDatePicker() {
      if (this.retrieveData.date && this.retrieveData.date.length === 2) {
        const [a, b] = this.retrieveData.date
        const sorted = day(a).isBefore(day(b)) ? [a, b] : [b, a]
        this.retrieveData.startDate = day(sorted[0]).format('YYYYMMDD')
        this.retrieveData.endDate   = day(sorted[1]).format('YYYYMMDD')
        this.$refs.menu.save(this.retrieveData.date)
      } else {
        this.retrieveData.startDate = ''
        this.retrieveData.endDate   = ''
        this.menu = false
      }
    },
    createGridColumns() {
      this.grid.gridColumns = [
        {
          name: 'accessDt', fieldName: 'accessDt',
          header: { text: '접속일시' },
          width: 150, editable: false
        },
        {
          name: 'userId', fieldName: 'userId',
          header: { text: '계정(아이디)' },
          width: 100, editable: false
        },
        {
          name: 'ipAddr', fieldName: 'ipAddr',
          header: { text: '접속 IP' },
          width: 120, editable: false,
          styles: { textAlignment: 'center' }
        },
        {
          name: 'operationType', fieldName: 'operationType',
          header: { text: '수행업무' },
          width: 70, editable: false,
          styles: { textAlignment: 'center' }
        },
        {
          name: 'subjectId', fieldName: 'subjectId',
          header: { text: '정보주체 ID' },
          width: 120, editable: false
        },
        {
          name: 'menuId', fieldName: 'menuId',
          header: { text: '메뉴 ID' },
          width: 120, editable: false
        },
        {
          name: 'apiUrl', fieldName: 'apiUrl',
          header: { text: 'API URL' },
          width: 200, editable: false
        },
        {
          name: 'httpMethod', fieldName: 'httpMethod',
          header: { text: 'HTTP' },
          width: 60, editable: false,
          styles: { textAlignment: 'center' }
        },
        {
          name: 'actionDesc', fieldName: 'actionDesc',
          header: { text: '행위 설명' },
          width: 160, editable: false
        },
        {
          name: 'logId', fieldName: 'logId',
          header: { text: '로그 ID' },
          width: 220, editable: false,
          styles: { textAlignment: 'center' }
        }
      ]
    }
  },
  beforeDestroy() {
    if (this.$refs.dataGrid) {
      this.$refs.dataGrid.destroy()
    }
  }
}
</script>
